import React, { useEffect } from 'react';
import styled from 'styled-components';
import PersonalDataContainer from '../containers/PersonalDataContainer';
import WelcomePage from '../containers/WelcomePage';
import SupplyAddressContainer from '../containers/SupplyAddressContainer';
import RecapContainer from '../containers/RecapContainer';
import ConsentContainer from '../containers/ConsentContainer';
import RecapPaymentContainer from '../containers/RecapPaymentContainer';
import { Route, withRouter } from "react-router-dom";
import { CallMeBackForm } from '../components/CallMeBack/CallMeBackForm';
import LastPageContainer from "../containers/LastPageContainer";
import { ROUTES } from '../utils/constants';
import { InfoPopup } from './ConsentsPage/InfoPopup';
import { TextBlock, BaseText } from '../components/text';
import { FontSize16 } from '../components/fonts';
import { MarginTop8 } from '../components/margins';
import { Popup } from '../components/Popup';
import { unloadListenerFunction } from '../utils/unloadListenerFunction';
import ChangeOfferContent from '../components/ChangeOfferContent';
import ChangeOfferPopup from '../components/ChangeOfferPopup';
import OfferLoadingLayer from '../components/OfferLoadingLayer';
import {ENV_VARIABLES} from "../envVariables";
import {PricingContainer} from "../components/Offer/style";
import {tcUnloadEvents} from "../utils/tcUnloadEvent";

const PopupTextStyle = styled(TextBlock)`
    ${BaseText};
    ${FontSize16};
    line-height: 24px;
    width: 100%;
    ${MarginTop8};
    padding: 0 16px;
`;

window.addEventListener('beforeunload', unloadListenerFunction);
// load tagcommander tc_events drop off no date save on tag commanders
window.addEventListener('beforeunload', tcUnloadEvents);
// 5862 both, 5866 energy, 5857 gas
// aklamio 8782 OfferType = Variabele both, 8169 energy 8777 gas

const RootComponent = props => {
    useEffect(() => {
        props.getTexts();
        props.checkDisplayCallMeButtons();
        const interval = setInterval(() => props.checkDisplayCallMeButtons(), 20 * 1000);

        let search = props.location.search;
       //console.log('backend url', ENV_VARIABLES.backendUrl)
        //if (!search) {
            //search = '?offerId=8912&tipologia_offerta=standard&referrer=corporate&code=PartnerTest';
             //search = '?offerId=5857&tipologia_offerta=variabile&referrer=corporate';
             //search = '?offerId=8782&tipologia_offerta=standard&referrer=corporate';
        //}
        if (!search) {
            window.location = "https://www.vivigas.it/prodotti/";
        } else {
            let parsedSearch = search.substring(1);
            parsedSearch = parsedSearch.split('&').reduce((prev, s) => {
                const values = s.split('=');
                return { ...prev, [values[0]]: values[1] }
            }, {});
            const { cx1, cx2, cx3 } = parsedSearch;
            props.setAnalytics({ cx1, cx2, cx3 });

            if (parsedSearch.referrer) {
                props.setReferrer(parsedSearch.referrer);
            }

            if (parsedSearch.otp) {
                props.getUserFromOtp(parsedSearch.otp, props.history);
            } else if (parsedSearch.offerId) {
                props.getOffer({
                    offerId: parsedSearch.offerId,
                    coupon: parsedSearch.code,
                    offerType: parsedSearch.tipologia_offerta, 
                    shouldShowPopupSelectedType: true,
                });
               if (parsedSearch.code){
                   props.history.push('/dati-personali');
               }else {
                   props.history.push('/');
               }


            } else {
                console.log("Error, missing both otp and offerId");
                window.location = "https://www.vivigas.it/prodotti/";
            }
        }

        return () => {
            console.log('Clearing interval');
            clearInterval(interval);
        }
    }, []);

    return (
        <React.Fragment>
            <Route exact path={ROUTES.home} component={WelcomePage} />
            <Route exact path={ROUTES.personalData} component={PersonalDataContainer} />
            <Route exact path={ROUTES.supply} component={SupplyAddressContainer} />
            <Route exact path={ROUTES.paymentRecap} component={RecapPaymentContainer} />
            <Route exact path={ROUTES.consents} component={ConsentContainer} />
            <Route exact path={ROUTES.recap} component={RecapContainer} />
            <Route exact path={ROUTES.endPage} component={LastPageContainer} />
            <CallMeBackForm
                {...props.callMeBackReducer}
                isVisible={props.isCallMeVisibile}
                trackName={props.trackName}
                toggle={props.toggleCallMeBack}
            />
            <InfoPopup
                closePopup={props.closePopup}
                content={{ title: props.popup.title, content: <PopupTextStyle dangerouslySetInnerHTML={{ __html: props.popup.text }}></PopupTextStyle> }}
                isOpen={props.popup.isOpen}
                isDismissableBackground={false}
            />
            {props.isPopupTimeGateOpen &&
                <Popup
                    isDismissableBackground={false}
                    close={props.closePodPdrTimeGatePopup}
                    buttonText="Torna alla Home"
                    title="Errore"
                >
                    <p style={{ padding: '8px', textAlign: 'center', margin: 0 }}>{props.popupTimeGateErrorMessage}</p>
                </Popup>
            }
            {props.isCouponInvalid &&
                <Popup
                    isDismissableBackground={false}
                    close={props.closePodPdrTimeGatePopup}
                    buttonText="Torna alla Home"
                    title="Errore"
                >
                    <p style={{ padding: '8px', textAlign: 'center', margin: 0 }}>Questo coupon non è valido o è già stato utilizzato!</p>
                </Popup>
            }
            {props.offer.offerType !='standard' && (
                <ChangeOfferPopup
                    {...props}
                />
            )}


            {!(props.offer && props.offer.name) && !props.isCouponInvalid &&  ( <OfferLoadingLayer /> )}
        </React.Fragment>

    )
}

export const Root = withRouter(RootComponent);